module.exports = __webpack_public_path__ + "img/jiashuhuijianshibanli.2870859e.png";